import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { Card } from 'components/TripCard/styles';

export const SectionTitle = styled.h3`
  max-width: 8em;
  margin-bottom: 32px;
  font-weight: 600;
  line-height: 1.13;
  letter-spacing: -0.5px;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const AllTripsWrapper = styled.div`
  & ${Card} {
    margin-bottom: 16px;
  }
`;
